/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ watts: NonNullable<unknown> }} Ui_More_Stats_NpInputs */

const en_ui_more_stats_np = /** @type {(inputs: Ui_More_Stats_NpInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`NP ${i?.watts} W`)
};

const de_ui_more_stats_np = /** @type {(inputs: Ui_More_Stats_NpInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`NP ${i?.watts} W`)
};

/**
* | output |
* | --- |
* | "NP {watts} W" |
*
* @param {Ui_More_Stats_NpInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_more_stats_np = /** @type {((inputs: Ui_More_Stats_NpInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_More_Stats_NpInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_more_stats_np(inputs)
	return de_ui_more_stats_np(inputs)
});